/* Fantastick – EU Gewährleistungsmitteilung V2
   Globale Event-Delegation: funktioniert auch mit dynamisch aktualisierten
   Shopify-Warenkörben, solange diese Asset-Datei einmal über theme.liquid geladen wird. */

(() => {
  if (window.FantastickEUGuaranteeV2Loaded) return;
  window.FantastickEUGuaranteeV2Loaded = true;

  let lastTrigger = null;

  function getDialogFromTrigger(trigger) {
    const root = trigger.closest('[data-fk-eu-root]');
    return root ? root.querySelector('[data-fk-eu-dialog]') : null;
  }

  function openDialog(trigger) {
    const dialog = getDialogFromTrigger(trigger);
    if (!dialog) return;

    const alreadyOpen = document.querySelector(
      '[data-fk-eu-dialog][open]'
    );

    if (alreadyOpen && alreadyOpen !== dialog && typeof alreadyOpen.close === 'function') {
      alreadyOpen.close();
    }

    lastTrigger = trigger;

    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }

    document.documentElement.classList.add('fk-eu-modal-open');

    requestAnimationFrame(() => {
      const closeButton = dialog.querySelector('[data-fk-eu-close]');
      if (closeButton) closeButton.focus({ preventScroll: true });
    });
  }

  function closeDialog(dialog) {
    if (!dialog) return;

    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
      document.documentElement.classList.remove('fk-eu-modal-open');

      if (lastTrigger) {
        lastTrigger.focus({ preventScroll: true });
        lastTrigger = null;
      }
    }
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-fk-eu-open]');
    if (trigger) {
      event.preventDefault();
      openDialog(trigger);
      return;
    }

    const closeButton = event.target.closest('[data-fk-eu-close]');
    if (closeButton) {
      event.preventDefault();
      closeDialog(closeButton.closest('[data-fk-eu-dialog]'));
      return;
    }

    const dialog = event.target.closest('[data-fk-eu-dialog]');
    if (dialog && event.target === dialog) {
      closeDialog(dialog);
    }
  });

  document.addEventListener('close', (event) => {
    if (!event.target.matches?.('[data-fk-eu-dialog]')) return;

    document.documentElement.classList.remove('fk-eu-modal-open');

    if (lastTrigger) {
      lastTrigger.focus({ preventScroll: true });
      lastTrigger = null;
    }
  }, true);

  document.addEventListener('cancel', (event) => {
    if (!event.target.matches?.('[data-fk-eu-dialog]')) return;
    document.documentElement.classList.remove('fk-eu-modal-open');
  }, true);
})();
